import { Space, Typography } from 'antd';
import { getI18n, useTranslation } from 'react-i18next';
import { startExportFilter } from '../../../services/admin/filters';
import { grispiNotification } from '../../../store/useNotificationStore';
import { tryCatch } from '../../MacroPage/MacroActionButton';

const { Link } = Typography;

const START_EXPORT = 'START_EXPORT';

type ExportFilterActionFunction = (filterId: number, callback: (filterId: number) => Promise<void>) => Promise<void>;

const exportFilterAction: ExportFilterActionFunction = async (filterId, callback) => {
    grispiNotification(
        'loading',
        getI18n().t('exportFilter.exportMessage.exportStarting', { ns: 'admin' }),
        START_EXPORT
    );

    tryCatch(async () => {
        await startExportFilter(filterId);
        grispiNotification(
            'success',
            getI18n().t('exportFilter.exportMessage.exportStarted', { ns: 'admin' }),
            START_EXPORT
        );
        await callback(filterId);
    }, START_EXPORT);
};
export default function FilterExportActionButton({
    filterId,
    callback
}: {
    filterId: number;
    callback: (filterId: number) => Promise<void>;
}) {
    const { t } = useTranslation('admin');

    return (
        <>
            <Space size="middle">
                <Link onClick={() => exportFilterAction(filterId, callback)}>{t('exportFilter.startExport')}</Link>
            </Space>
        </>
    );
}
